import { Container, Row, Col, Button } from "reactstrap";
import SidebarMenu from "./SidebarMenu";
import { Outlet, useNavigate } from "react-router-dom";

const AdminLayout = () => {
  const navigate = useNavigate();

  return (
    <Container fluid>
      <Row>
        <Col sm={2} md={2}>
          <Button color="primary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md="2" className="bg-light min-vh-100 p-0">
          <SidebarMenu />
        </Col>
        <Col md="10" className="p-3">
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
};

export default AdminLayout;
